
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portal/api-keys",
      function () {
        return require("private-next-pages/portal/api-keys.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portal/api-keys"])
      });
    }
  